module.exports = __webpack_public_path__ + "static/media/undraw_shopping_app_flsj.63d5d937.svg";